export default "__VITE_ASSET__BDE7Sy6D__"